import script from "./EzTableZeroMatchState.vue?vue&type=script&setup=true&lang=ts"
export * from "./EzTableZeroMatchState.vue?vue&type=script&setup=true&lang=ts"

import "./EzTableZeroMatchState.vue?vue&type=style&index=0&id=453c3492&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-453c3492"]])

export default __exports__